import React from "react";
//@ts-ignore
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { selectConfigData } from "../../redux/config/configSlice";
import { useAppSelector } from "../../redux/hooks";

const TelerikReporting = ({
  params,
  reportName,
  reportEndPoint,
}: {
  params: { [key: string]: any };
  reportName: string;
  reportEndPoint: string;
}) => {
  const configData = useAppSelector(selectConfigData);
  const token = localStorage.getItem("jwtToken") ?? null;

  const reportSource = {
    report: reportName, // name of the report file that you want to render
    parameters: {
      ReportUrl: `${configData?.appApiBaseUrl}/${reportEndPoint}`,
      AuthToken: `Bearer ${token}`,
      ...params,
    },
  };

  const hideNonPdfExports = () => {
    document
      .querySelectorAll<HTMLElement>("[data-command-parameter]")
      .forEach((item) => {
        const format = item.getAttribute("data-command-parameter");
        if (format && format !== "PDF") {
          item.style.display = "none";
        }
      });
  };

  const handleRenderingEnd = () => {
    // Hide non-PDF exports when menus open
    const largeMenu = document.querySelector(".trv-menu-large");
    if (largeMenu) {
      largeMenu.addEventListener("mouseover", hideNonPdfExports, {
        once: false,
      });
    }

    const sideMenu = document.querySelector(".trv-side-menu");
    if (sideMenu) {
      sideMenu.addEventListener("click", hideNonPdfExports, { once: false });
    }

    // Also run immediately to catch already-rendered items
    hideNonPdfExports();
  };

  return (
    <TelerikReportViewer
      reportSource={reportSource}
      viewerContainerStyle={{ height: "100%", width: "100%" }}
      serviceUrl={`${configData?.appApiBaseUrl}/reports`}
      // viewMode="PRINT_PREVIEW"
      scaleMode="FIT_PAGE_WIDTH"
      scale="1.0"
      enableAccessibility={false} // Disable accessibility if not needed
      renderingEnd={handleRenderingEnd}
    />
  );
};

export default TelerikReporting;
